// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import { Button, Select,Pagination,Dialog,
  Option,Input,Checkbox,Carousel,CarouselItem,MessageBox,Row,Col,Menu,Submenu,MenuItem,MenuItemGroup,
  Upload,Message,Cascader,Radio,Form,FormItem,RadioGroup, Loading,
} from 'element-ui';
import { post, get, put, _delete,upload } from '@/common/js/http'
import moment from 'moment/moment'
import "babel-polyfill"

//判断手机端直接跳转搭配wap
let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if(isMobile){
	//获取当前域名进行不同的跳转
	let domain = document.domain;
	if(domain.indexOf('resell')!==-1){
		window.location.href='http://i.hd199.com/Sed'
	}else if(domain.indexOf('market')!==-1){
		window.location.href='ttp://i.hd199.com/Lg';
	}else{
		window.location.href='http://i.hd199.com';
	}
}

import {getCookie} from '@/common/js/common'
// 引入进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

Vue.config.productionTip = false
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Upload)
Vue.use(Cascader)
Vue.use(Radio)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(RadioGroup)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$msgbox = MessageBox

// 在调用 Vue.use 前，给 Message 添加 install 方法
Message.install = function (Vue, options) {
	Vue.prototype.$message = (options) => {
		Message(Object.assign({duration: 900},options))
	}
}
Vue.use(Message)

// 全局对象
const vm = new Vue()
window.vm = vm

const routers = new VueRouter({
	mode: 'history',
	router
})
window.router = routers
Vue.use(VueRouter)
// post请求
Vue.prototype.$post = post
// get请求
Vue.prototype.$get = get
// put请求
Vue.prototype.$put = put
// put请求
Vue.prototype.$_delete = _delete
Vue.prototype.$upload = upload
// 注册全局路径
Vue.filter('link', function (value) {
  return  'lt.hd199.com' + value
  // 返回处理后的值
})

//时间过滤器
Vue.filter('time', function (value, formatString) {
	formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
	return moment.unix(value).format(formatString); // 这是时间戳转时间
});

// html特殊符号过滤
Vue.filter('escapeHtml', function (str) {
	var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
	return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];});
});

// 全局配置
router.beforeEach((to, from, next) => {
	if (to.meta.title) {//如果设置标题，拦截后设置标题
		document.title = to.meta.title+'_hd199影音新时代'
	}
  NProgress.start()
	next()
})

// 路由跳转成功
router.afterEach((to, from) => {
    NProgress.done()
})
// 全局变量 
window.uId = getCookie("user")?getCookie("user"):getCookie("dzq_user_id");
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})
//懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    error:'/static/image/error.jpg',
    loading:'/static/image/loading.gif'
})











// WEBPACK FOOTER //
// ./src/main.js